module.exports = require("@bechtel/client-gql");